export enum NavigationState {
  NONE,
  REVIEW,
  SETTINGS,
  ANALYTICS
}
